import React, { useState } from "react";
import { Avatar, Button, Tag, Typography, Icon } from "@ann/web-components";
import { useMyMemberContext } from "../../../../context";
import {
  ItemContainer,
  ItemHeader,
  ItemHeaderLeft,
  ItemHeaderRight,
  ItemContent,
  AvatarInfoContainer,
  ItemMeta,
  TagsContainer,
  RationaleBox,
  ComparisonSection,
  ComparisonRow,
  CurrentValue,
  SuggestedValue,
  ActionsContainer,
  ExpandIcon,
} from "./SuggestionItem.styled";

const SuggestionItem = ({ suggestion, groupId, onApprove, onDecline, isStandalone = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { myRole } = useMyMemberContext();

  const {
    suggestion_uuid,
    created_by,
    created_by_role,
    created_by_photo,
    created_at,
    formatted_date,
    comment,
    current_value,
    new_value,
  } = suggestion;

  // Determinar permisos según el rol
  const canApprove = myRole === 'ADMIN';

  const handleApprove = (e) => {
    e.stopPropagation();
    onApprove?.(groupId, suggestion_uuid);
  };

  const handleDecline = (e) => {
    e.stopPropagation();
    onDecline?.(groupId, suggestion_uuid);
  };

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const getAvatarLabel = () => {
    if (created_by_role === 'AI') {
      return "AI";
    }
    const name = created_by || 'Unknown';
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const getAvatarBackgroundColor = () => {
    if (created_by_role === 'AI') {
      return "00A07E"; 
    }
    return "2173FF"; 
  };

  const isAI = created_by_role === 'AI';
  const hasAgentTag = !isAI && created_by_role !== 'MANAGER';

  return (
    <ItemContainer $isStandalone={isStandalone}>
      <ItemHeader onClick={handleToggle}>
        <ItemHeaderLeft>
          <AvatarInfoContainer>
            <Avatar
              width={36}
              height={36}
              label={getAvatarLabel()}
              src={created_by_photo || `https://ui-avatars.com/api/?name=${encodeURIComponent(
                created_by || 'Unknown'
              )}&background=${getAvatarBackgroundColor()}&color=fff`}
            />
            <ItemMeta>
              <Typography category="body" size="medium" weight="bold">
                {created_by || 'Unknown'}
              </Typography>
              <Typography
                category="body"
                size="medium"
                weight="regular"
                color="body"
              >
                {formatted_date}
              </Typography>
            </ItemMeta>
          </AvatarInfoContainer>
          <Typography
            category="body"
            size="medium"
            weight="regular"
            color="body"
            maxCharacters={15}
          >
            Suggested Fact
          </Typography>
          <Typography
            category="body"
            size="medium"
            weight="regular"
            color="body"
            maxCharacters={50}
          >
            {new_value}
          </Typography>
        </ItemHeaderLeft>
        <ItemHeaderRight>
          <ActionsContainer onClick={(e) => e.stopPropagation()}>
            <Button
              label="Approve"
              size="medium"
              type="positive"
              onClick={handleApprove}
              // disabled={!canApprove} // TODO: Descomentar cuando myMember está funcionando
            />
            <Button
              label="Decline"
              size="medium"
              type="tertiary"
              onClick={handleDecline}
              // disabled={!canApprove} // TODO: Descomentar cuando myMember está funcionando
            />
            <Icon name="chevronDown" size="medium" onClick={handleToggle} />
          </ActionsContainer>
          <ExpandIcon $isExpanded={isExpanded}>
            <Typography category="body" size="small" color="body">
              {isExpanded ? "Hide details" : "View details"}
            </Typography>
          </ExpandIcon>
        </ItemHeaderRight>
      </ItemHeader>

      {isExpanded && (
        <ItemContent>
          {hasAgentTag && (
            <TagsContainer>
              <Tag
                color="success"
                size="medium"
                text="Agent"
              />
            </TagsContainer>
          )}

          {comment && (
            <RationaleBox>
              <Typography category="body" size="medium" weight="bold" color="title">
                Rationale: 
              </Typography>
              <Typography category="body" size="medium" weight="regular" color="body">
                {" "}
                {comment}
              </Typography>
            </RationaleBox>
          )}

          {(current_value || new_value) && (
            <ComparisonSection>
              {current_value && (
                <ComparisonRow>
                  <Typography category="body" size="small" weight="bold">
                    Current Value:
                  </Typography>
                  <CurrentValue>
                    <Typography category="body" size="medium" weight="regular" color="body">
                      {current_value}
                    </Typography>
                  </CurrentValue>
                </ComparisonRow>
              )}
              {new_value && (
                <ComparisonRow>
                  <Typography category="body" size="small" weight="bold">
                    Suggested Value:
                  </Typography>
                  <SuggestedValue>
                    <Typography category="body" size="medium" weight="regular" color="body">
                      {new_value}
                    </Typography>
                  </SuggestedValue>
                </ComparisonRow>
              )}
            </ComparisonSection>
          )}
        </ItemContent>
      )}
    </ItemContainer>
  );
};

export default SuggestionItem;
